import type {ReactElement} from 'react';
import React from 'react';
import type {ColorPickerProps} from '@Components/color-picker-v2';
import {ColorPicker} from '@Components/color-picker-v2';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {onAddBrandAssetClickedHandler} from '@Components/poster-editor/library/poster-editor-library';
import {updatePickingMode} from '@Components/poster-editor/poster-editor-reducer';
import {Canvas} from '@postermywall/fabricjs-2';
import {useAppDispatch, useAppSelector} from '@/hooks';

type ContextualMenuColorPanelProps = Omit<ColorPickerProps, 'scale' | 'onChangeColorPickerMode' | 'canvasRef' | 'canvasContainerRef' | 'onAddBrandAssetClicked' | 'onMyDesign'>;

export function PosterEditingBaseColorPanel({isAlphaDisabled = false, ...props}: ContextualMenuColorPanelProps): ReactElement<any> | null {
  const dispatch = useAppDispatch();
  const scale = useAppSelector((state) => {
    return state.posterEditor?.posterObject?.scaling.scale;
  });

  const getColorsOnMyDesign = (): string[] => {
    return window.posterEditor?.whiteboard?.getCurrentPage().getColorsOnPage() ?? [];
  };

  const onTogglePickerMode = (state: boolean): void => {
    dispatch(updatePickingMode(state));
  };
  const canvas = window.posterEditor?.whiteboard?.getCurrentPage().fabricCanvas;
  if (!(canvas instanceof Canvas)) {
    return null;
  }

  return (
    <ColorPicker
      id={props.id}
      className={props.className ?? ''}
      color={props.color}
      onMyDesign={getColorsOnMyDesign()}
      type={props.type}
      isGradientEnabled={props.isGradientEnabled}
      onChangeColor={props.onChangeColor}
      onChangeEnded={props.onChangeEnded}
      onChangeType={props.onChangeType}
      onAddBrandAssetClicked={(): void => {
        void onAddBrandAssetClickedHandler();
      }}
      scale={scale}
      canvasRef={canvas}
      canvasContainerRef={window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]}
      onChangeColorPickerMode={onTogglePickerMode}
      addDelayToOnChangeColor={props.addDelayToOnChangeColor}
      showSmallBrandDropdownHeader={false}
      isAlphaDisabled={isAlphaDisabled}
    />
  );
}
